import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';

import { changeScrollBehavior } from 'src/common/helpers';
import { Calculator, Setting } from 'src/components/core/icons';
import { FlexContainer } from 'src/components/core/layout/FlexContainer';
import { useKycAndFeaturesConfig } from 'src/hooks/useKycAndFeaturesConfig';

import { Form } from './form';
import { CalculatorModal } from '../modals/calculatorModal';
import { PreferencesModal } from '../modals/preferencesModal';

const StyledLabel = styled.span`
    ${({ theme: { typography } }) => `
        font-size: ${typography.size.desktop.paragraph.p2};
    `}
`;

const DesktopFormContainer: FC = () => {
    const { t } = useTranslation();
    const { colors } = useTheme();
    const { allowTrading } = useKycAndFeaturesConfig();

    const [isSettingModalOpen, setIsSettingModalOpen] = useState(false);
    const [isCalculatorModalOpen, setIsCalculatorModalOpen] = useState(false);

    return (
        <>
            <FlexContainer styles={{ justifyContent: 'space-between', padding: '10px 16px 12px' }}>
                <StyledLabel>{t('place_order')}</StyledLabel>
                <FlexContainer>
                    <Setting
                        className={!allowTrading ? 'clickable-disabled' : 'clickable'}
                        fill={colors.text.tertiary}
                        onClick={() => {
                            if (!allowTrading) {
                                return;
                            }

                            changeScrollBehavior(!isSettingModalOpen);
                            setIsSettingModalOpen(true);
                        }}
                    />
                    <Calculator
                        className={!allowTrading ? 'clickable-disabled' : 'clickable'}
                        fill={colors.text.tertiary}
                        stroke={colors.background.primary}
                        onClick={() => {
                            if (!allowTrading) {
                                return;
                            }

                            changeScrollBehavior(!isCalculatorModalOpen);
                            setIsCalculatorModalOpen(true);
                        }}
                    />
                </FlexContainer>
            </FlexContainer>
            <Form />
            {isSettingModalOpen && (
                <PreferencesModal
                    isOpen={isSettingModalOpen}
                    handleClose={() => {
                        changeScrollBehavior(!isSettingModalOpen);
                        setIsSettingModalOpen(false);
                    }}
                />
            )}
            {isCalculatorModalOpen && (
                <CalculatorModal
                    isOpen={isCalculatorModalOpen}
                    handleClose={() => {
                        changeScrollBehavior(!isCalculatorModalOpen);
                        setIsCalculatorModalOpen(false);
                    }}
                />
            )}
        </>
    );
};

export { DesktopFormContainer };
